/**
 * Para onde levar a pessoa depois de entrar, e como voltar para onde ela
 * estava.
 *
 * docs/AUTENTICACAO-E-ACESSO.md, secao 2, passo 8: papel interno vai para
 * /operacao; papel externo vai para o portal do transportador. A decisao usa o
 * campo `interno` do GET /eu — a aplicacao nao le papel do token e nao repete a
 * classificacao por conta propria.
 *
 * ATE A AREA DO CREDENCIADO EXISTIR, "portal do transportador" era `/` — a
 * mesma raiz do portal publico, sem sessao. Com `/credenciado` construida
 * (portal-credenciado/, mapa.ts), quem tem sessao e papel externo vai para la;
 * `/` continua sendo so o portal publico, para quem nao entrou.
 */

import { type UsuarioAutenticado } from './tipos';

export const CAMINHO_ENTRADA = '/login';
export const CAMINHO_OPERACAO = '/operacao';
export const CAMINHO_PORTAL = '/';
export const CAMINHO_CREDENCIADO = '/credenciado';

/**
 * Destino inicial do usuario.
 *
 * O documento tambem prevê /admin para papel de administracao. Enquanto essa
 * area nao existir, papel de administracao entra pela operacao: melhor que
 * mandar alguem para rota sem tela (CLAUDE.md, "Proibido"). Quando /admin
 * existir, muda so esta funcao.
 */
export function destinoDoUsuario(usuario: UsuarioAutenticado): string {
  return usuario.interno ? CAMINHO_OPERACAO : CAMINHO_CREDENCIADO;
}

/**
 * Normaliza o caminho para onde voltar depois da entrada.
 *
 * Aceita SO caminho interno. Endereco absoluto, `//outro-site` e `javascript:`
 * ficam de fora: este valor volta de `sessionStorage` depois de uma ida ao
 * Keycloak, e usar como destino de navegacao o que veio de fora seria
 * redirecionamento aberto — o classico de phishing "entrei no site certo e cai
 * no site errado".
 */
export function caminhoInternoSeguro(bruto: string | null | undefined, padrao = ''): string {
  if (!bruto) {
    return padrao;
  }

  const limpo = bruto.trim();

  if (!limpo.startsWith('/') || limpo.startsWith('//') || limpo.includes('\\')) {
    return padrao;
  }

  // Sem sentido voltar para a propria tela de entrada: cairia em laco visual.
  if (limpo === CAMINHO_ENTRADA || limpo.startsWith(`${CAMINHO_ENTRADA}?`)) {
    return padrao;
  }

  return limpo;
}

/** Caminho atual, com busca e ancora, para guardar antes de sair da pagina. */
export function caminhoAtual(local: Location | URL = window.location): string {
  return `${local.pathname}${local.search}${local.hash}`;
}
